function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import data_strategy_service from '@/services/data_strategy_service';
import utils from '@/js/utils';
import tasks from '@/js/tasks';
import { textsDefaul, envConfig, ACCESS_TYPE_FLOW, ENVIRONMENT_FLOW } from '@/js/constants';
var NOT_REPORTS = 'There are not report to assign';
export default {
  name: 'IndustryList',
  components: {},
  data: function data() {
    return {
      fields: [{
        key: 'industry',
        label: 'Industry',
        sortable: true
      }, {
        key: 'scope',
        label: 'Scope'
      }, {
        key: 'total_potential',
        label: 'Total Potential'
      }, {
        key: 'traditional',
        label: 'Traditional'
      }, {
        key: 'advanced',
        label: 'Advanced'
      }, {
        key: 'percentage',
        label: '%'
      }, {
        key: 'sub_scope',
        label: 'Sub Scope'
      }, {
        key: 'total_potential_anual',
        label: 'Total Potential Annual'
      }, {
        key: 'percentage_sale',
        label: '% Sale'
      }, {
        key: 'traditional_ai',
        label: 'Traditional AI'
      }, {
        key: 'mvps.length',
        label: 'MVPs'
      }, {
        key: 'active',
        label: 'Active'
      }, {
        key: 'creation_date',
        label: 'Creation Date',
        class: 'text-center'
      }, {
        key: 'creation_user',
        label: 'Creation User',
        class: 'text-center'
      }, {
        key: 'action',
        label: '',
        class: 'w-15 text-center'
      }],
      items: [],
      // Representa la colección de objetos
      data_list: [],
      new_item: {},
      // representa los datos generales
      messageEmptyList: textsDefaul.LOADING,
      path_name: '',
      limit: envConfig.pagintaionSize,
      page: 1,
      ACCESS_TYPE_FLOW: ACCESS_TYPE_FLOW,
      pagination: {
        total: 0,
        limit: 10,
        offset: 0,
        current: 1
      },
      isValidateLink: false,
      show_editor: false,
      readonly: false,
      nodes: {
        node1: {
          name: "Node 1"
        },
        node2: {
          name: "Node 2"
        },
        node3: {
          name: "Node 3"
        },
        node4: {
          name: "Node 4"
        }
      },
      edges: {
        edge1: {
          source: "node1",
          target: "node2"
        },
        edge2: {
          source: "node2",
          target: "node3"
        },
        edge3: {
          source: "node3",
          target: "node4"
        }
      },
      divisiones: [],
      source_systems: [],
      key_divisions: 0,
      key_macro_process: 0,
      new_macro_process: {},
      type_objects: [{
        value: 'TABLE',
        text: 'Table'
      }, {
        value: 'VIEW',
        text: 'View'
      }, {
        value: 'TBL_DATASOURCE',
        text: 'TBL Datasource'
      }, {
        value: 'TBL_DASHBOARD',
        text: 'TBL Dashboard'
      }, {
        value: 'PBI_DATASET',
        text: 'PBI Dataset'
      }, {
        value: 'PBI_REPORT',
        text: 'PBI Report'
      }, {
        value: 'GDS_REPORT',
        text: 'GDS Report'
      }],
      plan_pilares: [],
      size_modal: 'md',
      is_add_macro_process: false,
      key_sub_macro_process: 0,
      new_sub_macro_process: '',
      mvps: []
    };
  },
  computed: {
    isEmptyTable: function isEmptyTable() {
      return !this.items.length;
    },
    composeName: function composeName() {
      return function () {
        var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var text = '';
        if (item) {
          text = "".concat(item.path_name, "/").concat(item.object_name).replace(/\//g, '&nbsp;/&nbsp;');
        }
        return text;
      };
    },
    getDivisionName: function getDivisionName() {
      var _this = this;
      return function () {
        var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var find = _this.divisiones.find(function (x) {
          return x.value == item.division_id;
        });
        if (find) return find.text;
        return "";
      };
    },
    getPlanPilarName: function getPlanPilarName() {
      var _this2 = this;
      return function () {
        var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var find = _this2.plan_pilares.find(function (x) {
          return x.value == item.plan_pilar_id;
        });
        if (find) return find.text;
        return "";
      };
    }
  },
  created: function created() {
    this.reloadList();
    this.loadDivisions();
    this.loadPlanPilares();
    this.loadMvps();
  },
  methods: {
    loadPlanPilares: function loadPlanPilares() {
      var _this3 = this;
      var defaultParams = {
        pagination: {
          limit: 1000,
          offset: 0
        }
      };
      data_strategy_service.getPlanPilarAll(defaultParams).then(function (res) {
        res.data.forEach(function (element) {
          _this3.plan_pilares.push({
            text: element.name,
            value: element.id
          });
        });
      });
    },
    loadDivisions: function loadDivisions() {
      var _this4 = this;
      var defaultParams = this.processParams(null);
      data_strategy_service.getDivisionAll(defaultParams).then(function (res) {
        res.data.forEach(function (element) {
          _this4.divisiones.push({
            id: element.id,
            name: element.name
          });
        });
      });
    },
    loadMvps: function loadMvps() {
      var _this5 = this;
      var defaultParams = {
        pagination: {
          limit: 1000,
          offset: 0
        }
      };
      data_strategy_service.getMvpAll(defaultParams).then(function (res) {
        res.data.forEach(function (element) {
          _this5.mvps.push({
            id: element.id,
            description: element.description
          });
        });
      });
    },
    processParams: function processParams(params) {
      var filters = [{
        key: 'environment',
        operator: 'in',
        value: [ENVIRONMENT_FLOW.DEV, ENVIRONMENT_FLOW.TEST]
      }];
      if (params && params.clauses) {
        var clauses = params.clauses;
        if (clauses.query_type !== 'advanced') {
          for (var _i = 0, _Object$keys = Object.keys(clauses); _i < _Object$keys.length; _i++) {
            var key = _Object$keys[_i];
            if (clauses[key] && clauses[key].trim()) {
              filters.push({
                key: key,
                operator: '==',
                value: clauses[key].trim()
              });
            }
          }
        }
      }
      return _objectSpread({
        domain: window.userInfo.domain,
        pagination: {
          limit: this.pagination.limit,
          offset: this.pagination.offset
        },
        filters: filters
      }, params);
    },
    reloadList: function reloadList(params) {
      var _this6 = this;
      this.items = [];
      var defaultParams = this.processParams(params);
      this.messageEmptyList = textsDefaul.LOADING;
      data_strategy_service.getIndustryAll(defaultParams).then(function (res) {
        if (res && res.code === 200) {
          _this6.items = res.data;
          _this6.data_list = Object.assign([], res.data);
          _this6.pagination.total = res.data.length;
          _this6.currentPage = 1;
          _this6.messageEmptyList = res.data.length === 0 ? NOT_REPORTS : null;
        } else if (res && res.code === 400) {
          console.info(res);
        }
      }).catch(function (e) {
        utils.printError(e);
      });
    },
    validateKey: function validateKey(key, model) {
      if (!(key in model)) return false;
      if (model[key].toString().trim() == 0) return false;
      return true;
    },
    validateNew: function validateNew() {
      console.log(this.new_item);
      var divis = this.divisiones.filter(function (element) {
        return element.check == true;
      });
      if (divis.length > 0) {
        this.new_item.divisions = divis;
      }
      if (!this.validateKey('industry', this.new_item)) {
        this.$toast.warning("Enter the industry!");
        return false;
      }
      return true;
    },
    onSaveIndustry: function onSaveIndustry() {
      var _this7 = this;
      var ms = this.mvps.filter(function (x) {
        return x.check == true;
      });
      if (ms.length > 0) {
        this.new_item.mvps = ms;
      }
      if (!this.validateNew()) return;
      var data = {
        values: this.new_item
      };
      if (this.new_item.id) {
        data_strategy_service.updateIndustry(data).then(function (res) {
          console.log(res);
          if (res.success) {
            _this7.$bvModal.hide('my-modal-industry');
            _this7.$toast.success("Successful request!");
            _this7.reloadList();
          } else {
            _this7.$toast.warning(res.message);
          }
        });
      } else {
        data_strategy_service.createIndustry(data).then(function (res) {
          console.log(res);
          if (res.success) {
            _this7.$bvModal.hide('my-modal-industry');
            _this7.$toast.success("Successful request!");
            _this7.reloadList();
          } else {
            _this7.$toast.warning(res.message);
          }
        });
      }
    },
    onDelete: function onDelete(item) {
      var _this8 = this;
      console.log(item);
      var data = {
        "system_id": item.id
      };
      data_strategy_service.deleteIndustryById(data).then(function (res) {
        console.log(res);
        if (res.success) {
          _this8.$bvModal.hide('my-modal-industry');
          _this8.$toast.success("Successful request!");
          _this8.reloadList();
        } else {
          _this8.$toast.warning(res.message);
        }
      });
    },
    onCloseModal: function onCloseModal() {
      this.$bvModal.hide('my-modal-industry');
      this.new_item = {};
    },
    onCancel: function onCancel() {
      this.onCloseModal();
    },
    onPage: function onPage(page) {
      this.page = page;
      this.reloadList({
        page: page
      });
    },
    changePagina: function changePagina(pagina) {},
    onOpenNew: function onOpenNew() {
      this.new_item = {};
      this.divisiones.forEach(function (x) {
        x.check = false;
      });
      this.isValidateLink = true;
      this.$refs['my-modal-industry'].show();
    },
    onIsAddMacroProcess: function onIsAddMacroProcess() {
      this.is_add_macro_process = true;
    },
    onAddMacroProcess: function onAddMacroProcess() {
      var _this9 = this;
      this.$nextTick().then(function () {
        if (!_this9.validateKey('name', _this9.new_macro_process)) {
          _this9.$toast.warning("Enter the name!");
          return;
        }
        if (!_this9.validateKey('definition', _this9.new_macro_process)) {
          _this9.$toast.warning("Enter the definition!");
          return;
        }
        if ('macro_process' in _this9.new_item) {
          _this9.new_item.macro_process.push(_this9.new_macro_process);
        } else {
          _this9.new_item.macro_process = [_this9.new_macro_process];
        }
        _this9.key_macro_process += 1;
        _this9.new_macro_process = {};
        _this9.new_sub_macro_process = '';
        _this9.onCancelAddMacroProcess();
        //this.$refs['okrs-list'].$forceUpdate()
      });
    },
    onDelMacroProcess: function onDelMacroProcess(index) {
      this.new_item.macro_process.splice(index, 1);
      this.key_macro_process += 1;
    },
    onEdit: function onEdit(item) {
      var _this0 = this;
      this.new_item = Object.assign({}, item);
      this.mvps.forEach(function (element) {
        var filter = _this0.new_item.mvps.filter(function (x) {
          return x.id == element.id;
        });
        if (filter.length > 0) {
          element.check = true;
        } else {
          element.check = false;
        }
      });
      this.$refs['my-modal-industry'].show();
    },
    isAddMacroProcess: function isAddMacroProcess() {
      if (this.is_add_macro_process) {
        return 'col-6';
      } else {
        return 'col-12';
      }
    },
    onCancelAddMacroProcess: function onCancelAddMacroProcess() {
      this.new_macro_process = {};
      this.is_add_macro_process = false;
    },
    onAddSubMacro: function onAddSubMacro() {
      var _this1 = this;
      this.$nextTick().then(function () {
        if (!(_this1.new_sub_macro_process.trim().length > 0)) {
          _this1.$toast.warning("Enter the sub macro process!");
          return;
        }
        if ('sub_macro_process' in _this1.new_macro_process) {
          _this1.new_macro_process.sub_macro_process.push(_this1.new_sub_macro_process);
        } else {
          _this1.new_macro_process.sub_macro_process = [_this1.new_sub_macro_process];
        }
        _this1.key_sub_macro_process += 1;
        _this1.new_sub_macro_process = '';
        //this.$refs['okrs-list'].$forceUpdate()
      });
    },
    onDelSubMacro: function onDelSubMacro(index) {
      this.new_item.macro_process.splice(index, 1);
      this.key_macro_process += 1;
    }
  }
};